import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=e73f6fc6&scoped=true&"
import script from "./OrderOverview.vue?vue&type=script&lang=js&"
export * from "./OrderOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=e73f6fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73f6fc6",
  null
  
)

export default component.exports